/**
 * Território do projeto ({ "<nome do estado>": ["<cidade>", …] }).
 *
 * Espelha o helper do backend (`src/helpers/RealizationAddress.js`): em PROJETO,
 * toda UF precisa de ao menos uma cidade. "Todo o estado" (lista vazia) segue
 * valendo na SELETIVA e nos filtros de listagem do admin, que são busca e não
 * cadastro.
 */

/** Estados presentes no território que estão sem nenhuma cidade. */
export const missingCityStates = (address) => {
  if (!address || typeof address !== "object") return [];

  return Object.keys(address).filter((state) => {
    const cities = address[state];

    return (
      !Array.isArray(cities) ||
      !cities.filter((city) => String(city ?? "").trim()).length
    );
  });
};

/** Mensagem única nomeando os estados pendentes (vazio quando está tudo certo). */
export const missingCityMessage = (address) => {
  const states = missingCityStates(address);

  if (!states.length) return "";

  return `Informe ao menos uma cidade para: ${states.join(", ")}.`;
};

export const MISSING_CITY_MESSAGE = "Selecione ao menos uma cidade.";
